module.exports = __webpack_public_path__ + "static/media/d3.e61926aa.svg";